import React from 'react';
/* eslint-disable */
export function RemoveCondition(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none" {...props}>
      <path
        d="M13.1807 14.0829L0.914062 1.81621L1.86406 0.866211L14.1307 13.1329L13.1807 14.0829ZM10.5474 7.66621L9.21406 6.33288H11.9974V7.66621H10.5474ZM7.21406 4.33288L5.88073 2.99954H13.9974V4.33288H7.21406ZM6.66406 10.9995V9.66621H9.33073V10.9995H6.66406ZM3.9974 7.66621V6.33288H6.76406V7.66621H3.9974ZM1.9974 4.33288V2.99954H3.43073V4.33288H1.9974Z"
        fill="currentColor"
      />
    </svg>
  );
}
